import imgSchermAfbeelding20240523Om10191 from "../assets/map-safari-popup.webp";

function SatelliteMap() {
	return (
		<div className="overflow-clip relative rounded-[8px] shrink-0 size-[120px]" data-name="satelliteMap">
			<div className="absolute h-[166.098px] left-[-39.51px] top-[-24.88px] w-[202.057px]" data-name="Scherm­afbeelding 2024-05-23 om 10.19 1">
				<img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgSchermAfbeelding20240523Om10191} />
			</div>
		</div>
	);
}

export default function Frame() {
	return (
		<div className="content-stretch flex flex-col gap-[8px] items-start relative size-full">
			<SatelliteMap />
			<div className="flex flex-col font-['Poppins:Medium',sans-serif] justify-center leading-[0] not-italic relative shrink-0 text-[#0f3e4a] text-[12px] whitespace-nowrap">
				<p className="leading-[normal]">Satellite</p>
			</div>
		</div>
	);
}
